import { render, staticRenderFns } from "./NarrowCol.vue?vue&type=template&id=707c08e3&scoped=true&"
import script from "./NarrowCol.vue?vue&type=script&lang=js&"
export * from "./NarrowCol.vue?vue&type=script&lang=js&"
import style0 from "./NarrowCol.vue?vue&type=style&index=0&id=707c08e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707c08e3",
  null
  
)

export default component.exports